"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 1c6.065 0 11 4.934 11 11 0 6.065-4.935 11-11 11-6.066 0-11-4.935-11-11C1 5.933 5.934 1 12 1Zm0 1.878c-5.03 0-9.122 4.093-9.122 9.122 0 5.03 4.093 9.122 9.121 9.122 5.03 0 9.123-4.092 9.123-9.123 0-5.028-4.093-9.12-9.123-9.12Zm0 12.58a1.17 1.17 0 1 1 0 2.34 1.17 1.17 0 0 1 0-2.34Zm-.044-9.005c.694 0 1.273.095 1.737.285.463.19.838.427 1.12.711.284.285.487.589.608.917.123.326.184.632.184.915 0 .47-.061.855-.184 1.158a2.81 2.81 0 0 1-.454.777 3.02 3.02 0 0 1-.6.55c-.22.151-.428.303-.624.454a2.922 2.922 0 0 0-.52.52 1.416 1.416 0 0 0-.256.563l-.03.17v.557h-1.978v-.66c.03-.42.11-.772.242-1.055.132-.283.286-.525.461-.726a3.7 3.7 0 0 1 .557-.52 8.24 8.24 0 0 0 .542-.44c.166-.147.302-.307.404-.483.102-.175.148-.395.14-.66 0-.449-.11-.78-.33-.996-.22-.215-.527-.323-.917-.323-.263 0-.49.051-.681.155-.19.102-.347.239-.469.41-.123.17-.213.37-.271.6a2.801 2.801 0 0 0-.082.546l-.005.195H8.394c.01-.529.1-1.011.273-1.451.17-.44.41-.82.717-1.144a3.223 3.223 0 0 1 1.114-.753 3.754 3.754 0 0 1 1.458-.272Z",
    clipRule: "evenodd"
  })]
});